import NiceDropdown from 'components/NiceDropdown';
import React, { useEffect, useState } from 'react';
import { FiChevronDown, FiCalendar } from 'react-icons/fi';
import { Button, Box } from 'rebass';

import { useQueryParams } from 'hooks/useQueryParams';

// id is a value. Constrains of NiceDropdown.
const options = [
    {
        id: '1',
        title: 'Last day'
    },
    {
        id: '30',
        title: 'Last 30 days'
    },
    {
        id: '60',
        title: 'Last 60 days'
    },
    {
        id: '90',
        title: 'Last 90 days'
    },
    {
        id: '365',
        title: 'Last year'
    }
];

export function CalendarSelect() {
    const { query, setQuery } = useQueryParams();
    const [isOpen, setIsOpen] = useState(false);
    const [selected, setSelected] = useState(() => {
        const defaultId = query.daysAgo || '30';
        return options.find(option => option.id === defaultId) || options[0];
    });

    const onChange = id => {
        const selectedOption = options.find(option => option.id === id);

        if (!selectedOption) return;

        setSelected(selectedOption);
    };

    useEffect(() => {
        setQuery({ daysAgo: selected.id });
    }, [selected]);

    return (
        <Box sx={{ position: 'relative' }}>
            <Button variant="secondary-gray" onClick={() => setIsOpen(isOpen => !isOpen)}>
                <FiCalendar /> {selected.title} <FiChevronDown />
            </Button>
            {isOpen && (
                <NiceDropdown
                    value={selected.id}
                    onClose={() => setIsOpen(false)}
                    onChange={onChange}
                    items={options}
                />
            )}
        </Box>
    );
}

export default CalendarSelect;
